import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36522c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card h-100 shadow-sm" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "card-body d-flex flex-column text-center" }
const _hoisted_4 = { class: "card-title text-center" }
const _hoisted_5 = { class: "card-text flex-grow-1" }



interface Brand {
    name: string;
    slug: string;
    description: string;
    logo?: string;
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandCard',
  props: {
    brand: {},
    cardColor: {}
  },
  setup(__props: any) {

const props = __props;

const getAssetUrl = (imageFileName: string) => {
    if (imageFileName.startsWith('https://')) {
        return imageFileName;
    }
    return new URL(`../assets/images/${imageFileName}`, import.meta.url).href;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-header image-header",
      style: _normalizeStyle({ backgroundColor: _ctx.cardColor || '#f8f9fa' })
    }, [
      _createElementVNode("img", {
        src: _ctx.brand.logo!,
        alt: _ctx.brand.name + ' Logo',
        class: "brand-logo"
      }, null, 8, _hoisted_2)
    ], 4),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.brand.name), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.brand.description), 1),
      _createVNode(_component_router_link, {
        to: '/' + _ctx.brand.slug,
        class: "btn btn-outline-primary mt-auto",
        style: _normalizeStyle({ borderColor: _ctx.cardColor, color: _ctx.cardColor })
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Ver Más ")
        ]),
        _: 1
      }, 8, ["to", "style"])
    ])
  ]))
}
}

})